import {useQuery} from '@tanstack/react-query'

import {
  aggregateUserInterests,
  createBskyTopicsHeader,
} from '#/lib/api/feed/utils'
import {getContentLanguages} from '#/state/preferences/languages'
import {STALE} from '#/state/queries'
import {usePreferencesQuery} from '#/state/queries/preferences'
import {useBlueskyAppviewRequestTarget} from '#/state/session'
import {app} from '#/lexicons'

export const DEFAULT_LIMIT = 15

export const createGetSuggestedFeedsQueryKey = () => ['suggested-feeds']

export function useGetSuggestedFeedsQuery({enabled}: {enabled?: boolean}) {
  const {client, service} = useBlueskyAppviewRequestTarget()
  const {data: preferences} = usePreferencesQuery()
  const savedFeeds = preferences?.savedFeeds

  return useQuery({
    enabled: !!preferences && enabled !== false,
    staleTime: STALE.MINUTES.THREE,
    queryKey: createGetSuggestedFeedsQueryKey(),
    queryFn: async () => {
      const contentLangs = getContentLanguages().join(',')
      const params = {limit: DEFAULT_LIMIT}
      const headers = {
        ...createBskyTopicsHeader(aggregateUserInterests(preferences)),
        'Accept-Language': contentLangs,
      }
      const data = await client.call(
        app.bsky.unspecced.getSuggestedFeeds,
        params,
        {headers, service},
      )

      return {
        /*
         * Preserve the response position when filtering saved feeds so
         * feedback refers to the rank from the recommendation batch.
         */
        feeds: data.feeds.flatMap((feed, position) => {
          const isSaved = !!savedFeeds?.find(s => s.value === feed.uri)
          return isSaved ? [] : [{feed, position}]
        }),
        recId: data.recIdStr,
      }
    },
  })
}
